import Transition from './Transition';
import Fade from './Fade';
import Collapse from './Collapse';
import Bounce from './Bounce';
import Slide from './Slide';
var Animation = {
  Transition: Transition,
  Fade: Fade,
  Collapse: Collapse,
  Bounce: Bounce,
  Slide: Slide
};
export default Animation;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rsuite/es/Animation/index.js
// module id = 3209
// module chunks = 31